// Modules
import { FieldArray, Field } from 'redux-form';
import PropTypes from 'prop-types';
import React from 'react';

import { EMAIL_TYPES } from 'constants';
import { RemoveButton } from 'components/widgets/buttons';
import { Row, Subform, SubformHeader } from 'components/forms/form-structure';
import { TextInput, SelectInput, CheckboxInput } from 'components/forms/form-elements';
import { convertArrayToOptions } from 'utils/input-utils';
import { preventDefault } from 'utils/event-handlers';

class RenderEmails extends React.Component {
  static propTypes = {
    fields: PropTypes.object,
    change: PropTypes.func,
    meta: PropTypes.object,
    allowPrimary: PropTypes.bool
  };

  constructor() {
    super();

    this.inputs = [];
    this.setPrimary = this.setPrimary.bind(this);
  }

  setPrimary(event, index) {
    if (!event.target.checked) return;

    const { fields, change } = this.props;

    fields.forEach((name, fieldIndex) => {
      if (fieldIndex !== index) change(`${name}.primary`, false);
    });
  }

  render() {
    const { fields, allowPrimary, meta } = this.props;

    return (
      <Subform>
        <SubformHeader>
          Email Addresses
          { meta.error && meta.error !== ' ' && <div className="invalid-alert">{meta.error}</div> }
        </SubformHeader>
        <div className="email-address-input-list">
          { fields.map((name, index) =>
            <Row key={index}>
              <Field component={TextInput} name={`${name}.email`} autoFocus={fields.get(index).isNew} />
              <Field component={SelectInput} name={`${name}.type`} elementClasses="type-select" options={convertArrayToOptions(EMAIL_TYPES)} />
              <span className="primary-email-select">
                { allowPrimary &&
                  <Field
                    component={CheckboxInput}
                    label="Primary"
                    name={`${name}.primary`}
                    onChange={(event) => this.setPrimary(event, index)}
                  />
                }
                <RemoveButton onClick={() => fields.remove(index)} className="margin-left" />
              </span>
            </Row>
          ) }
          <a href="" onClick={preventDefault(() => fields.push({ primary: !fields.length && allowPrimary, isNew: true, type: 'Work' }))}>Add Email Address</a>
        </div>
      </Subform>
    );
  }
}

// Component
export default function EmailForm(props) {
  return <FieldArray {...props} component={RenderEmails} name="emailAddresses" />;
}
